import script from "./UserManagementTreeNode.vue?vue&type=script&setup=true&lang=js"
export * from "./UserManagementTreeNode.vue?vue&type=script&setup=true&lang=js"

import "./UserManagementTreeNode.vue?vue&type=style&index=0&id=4308db7a&lang=scss&scoped=true"

import exportComponent from "/root/buildarea/v8-production-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4308db7a"]])

export default __exports__